<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 100 100"
    class="svg-icon"
  >
    <path fill="none" d=" M 95  5 L 10 50 L 95 95" :stroke="color" stroke-width="7px" />
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-lower-than",
  components: {},
})
export class IconLowerThan extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconLowerThan;
</script>
